import { render, staticRenderFns } from "./formsettinglist.vue?vue&type=template&id=01515908&scoped=true"
import script from "./formsettinglist.vue?vue&type=script&lang=js"
export * from "./formsettinglist.vue?vue&type=script&lang=js"
import style0 from "./formsettinglist.vue?vue&type=style&index=0&id=01515908&prod&scoped=true&lang=scss"
import style1 from "./formsettinglist.vue?vue&type=style&index=1&id=01515908&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01515908",
  null
  
)

export default component.exports